import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonMapItem } from '../polygon-map-item';

@RegisterElement()
export class IslandElement extends PolygonMapItem {
    public override TypeName: string = "Island";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "MapItems";

    constructor(formGroup: FormGroup) {
        super(formGroup, "Island");
        
        
    }

    override default(): IslandElement {
        this.points = [
            { x: 0, y: 0 },
            { x: 3, y: 0 },
            { x: 3, y: 3 },
            { x: 0, y: 3 }
        ];
        this.formGroup.patchValue({
            Name: '',
            width: 3,
            height: 3
        });
        return this;
    }

    override clone(): IslandElement {
        return new IslandElement(
            this.formGroup
        );
    }

    override toJSON(): object {
        return {
            ...super.toJSON(),
            type: 'island'
        };
    }

    override fromJSON(json: any): void {
        if (json.type === 'island') {
            super.fromJSON(json);
        }
    }


    override updateForm(): void {
        super.updateForm();
    }

    
}
